import {objectToFormDataNotNullValueFields} from '@/functions';
import BaseModel from '../BaseModel';

export default class Article extends BaseModel {
  static entity = 'articles';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      companyId: this.attr(null),
      title: this.attr(null),
      content: this.attr(null),
      author: this.attr(null),
      status: this.attr(null),
      previewUrl: this.attr(null),
      createdAt: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      async fetchAll(companyId) {
        await this.get(`companies/${companyId}/all_articles`);
      },
      async store(payload) {
        return this.post('companies/articles', objectToFormDataNotNullValueFields(payload));
      },
      async publish(articleId, payload) {
        await this.post(`companies/articles/${articleId}/publish`, objectToFormDataNotNullValueFields(payload));
      },
      async removePublication(articleId) {
        await this.post(`companies/articles/${articleId}/remove_publication`);
      },
      async setPreview(articleId, payload) {
        await this.post(`companies/articles/${articleId}/set_preview`, payload);
      },
      async deleteArticle(articleId) {
        await this.delete(`companies/articles/${articleId}`);
      },
      async fetchArticle(articleId) {
        await this.get(`companies/articles/with_draft/${articleId}`);
      },
      async updateArticle(articleId, payload) {
        await this.post(`companies/articles/${articleId}/update`, objectToFormDataNotNullValueFields(payload));
      },
    },
  }
}
